import { SessionQuery } from 'apps/cmg-clear2-ui/src/app/core/state';
import { Cmg1003FileDataQuery, Cmg1003LoanQuery } from 'apps/cmg-clear2-ui/src/app/loan-state';
import { SyncType } from 'apps/cmg-clear2-ui/src/app/models';
import { combineLatest, distinctUntilChanged, filter, map } from 'rxjs';
import { fhaRefinancePurposeOptions, LoanPurposeType, MortgageType, otherRefinancePurposeOptions, vaRefinancePurposeOptions } from '../../../models';

export const isSyncedSecondOrThirdLienGovernmentLoan$ = (
  sessionQuery: SessionQuery,
  fileDataQuery: Cmg1003FileDataQuery,
  loanQuery: Cmg1003LoanQuery,
) => {
  return combineLatest({
    all1003Loaded: sessionQuery.select((s) => s.all1003Loaded),
    syncType: fileDataQuery.select((f) => f.syncType),
    mortgageType: loanQuery.select((l) => l.mortgageAppliedFor),
  }).pipe(
    filter(({ all1003Loaded }) => {
      return all1003Loaded;
    }),
    map((results) => {
      return (
        (results.syncType === SyncType.SecondLien || results.syncType === SyncType.ThirdLien) &&
        [MortgageType.fha, MortgageType.va, MortgageType.usda].includes(results.mortgageType)
      );
    }),
    distinctUntilChanged(),
  );
};

export const isGvtLoan = (mortgageType: MortgageType) => {
  return [MortgageType.fha, MortgageType.va, MortgageType.usda].includes(mortgageType);
};

export const getRefinancePurposeOptions = (loanPurposeType: LoanPurposeType, mortgageType: MortgageType) => {
  if (loanPurposeType === LoanPurposeType.refinance) {
    if (mortgageType === MortgageType.fha) {
      return fhaRefinancePurposeOptions;
    } else if (mortgageType === MortgageType.va) {
      return vaRefinancePurposeOptions;
    } else {
      return otherRefinancePurposeOptions;
    }
  }
  return [];
};
